import constants from '../utils/constants';
import filesService from "../services/files";
import scheduledFileService from '../services/scheduledFile';

const uploadFile = async (item, box, field, instance, email, setField) => {

    let fields = [];
    let file = {};

    for (const boxField of box.fields) {
        if (boxField.table && boxField.dataSource.length === 0) {
            if (field[boxField.id])
                fields.push({
                    idFieldTable: boxField.idFieldTable,
                    column: null,
                    value: typeof field[boxField.id] !== 'object' ? field[boxField.id] : field[boxField.id].id,
                })
        }

        if (boxField.table && boxField.dataSource.length > 0) {
            let idColumn = boxField.dataSource[0];
            for (const boxField1 of box.fields) {
                if (Number(boxField1.id) === Number(idColumn)) {
                    if (boxField1.idFieldTable) {
                        fields.push({
                            idFieldTable: boxField.idFieldTable,
                            column: null,
                            value: typeof field[idColumn] !== 'object' ? field[idColumn] : field[idColumn].id,
                        })
                    } else {
                        fields.push({
                            idFieldTable: boxField.idFieldTable,
                            column: field[idColumn],
                            value: null
                        })
                    }
                }
            }
        }

        if (boxField.type === 'File') {
            let idFile = boxField.id;
            file = field[idFile];
            setField(prevState => ({
                ...prevState,
                [idFile]: null,
            }), []);
            document.getElementById(idFile).value = "";
        }
    }

    if (file) {
        if (!file.name.includes('xlsx')) {
            return {
                error: "El archivo a subir tiene que ser formato xlsx"
            }
        } else {
            const formData = new FormData();
            formData.append('attachments', file);
            formData.append('bucket', constants.CLIENT_STORAGE);
            formData.append('folder', `${instance}/${item.function}`);
            await filesService.saveFiles(formData).then((response) => {
                for (let r = 0; r < response.data.length; r++) {

                    let request = {
                        name: response.data[r],
                        userEmail: email,
                        executes: {
                            fechaHora: new Date(),
                            estado: "En proceso"
                        },
                        fields
                    }

                    scheduledFileService.save(constants.CLIENT, instance, item.function, request).then((response) => {
                    }).catch((error) => {
                        console.log(error);
                    });
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }
}

export default uploadFile;